import React from "react";
import { PropertyContext } from "../pages/PropertyContext.web";
import { useFlightContext } from "./useFlightContext";

// see https://office.visualstudio.com/OC/_git/ShellServices?path=%2Fsources%2FShellService%2Fsrc%2FUserExperience.cs&_a=contents&version=GBmaster
export type LicenseType =
  | "CopilotBusinessChat"
  | "OfficeProPlus"
  | "CopilotTeams"
  | "Copilot";

export const useFeatureEnablement = () => {
  const { isFlightActive } = useFlightContext();
  const [siteSetting] = React.useContext(PropertyContext);

  const includesAny = React.useCallback(
    (allLicenses: string[] | undefined, checkForAny: LicenseType[]) => {
      if (!allLicenses) {
        return false;
      }

      const allLicensesHashed = new Set(allLicenses);
      for (const checkFor of checkForAny) {
        if (allLicensesHashed.has(checkFor)) {
          return true;
        }
      }
      return false;
    },
    []
  );

  return {
    isTryInOnAuthed: isFlightActive("isTryInEnabled") && !!siteSetting.user,
    isTryInRetrieveWorkingFiles:
      isFlightActive("isTryInEnabled") &&
      !!siteSetting.user &&
      isFlightActive("isTryInOfficeEnabled"),
    includesAny,
    isWorkgroupPublishingEnabled:
      isFlightActive("isWorkgroupPublishingEnabled") &&
      !!siteSetting.user &&
      siteSetting.user.type === "AAD",
  };
};
